import ClubSubscriptionItem from './ClubSubscriptionItem';
import { isShipmentAdjustable, listItemsForClub } from './helpers';

const ClubSubscriptionInfo = (props) => {
  const { club, clubSubscriptionShipment } = props;
  if (!isShipmentAdjustable(clubSubscriptionShipment)) {
    return null;
  }
  const items = listItemsForClub(clubSubscriptionShipment, club);
  return (
    <>
      <div className="c7-account-row c7-account-row--basic">
        <h3>Club Options</h3>
        <p>
          Add from the items below to customize your club shipment.
          <br />
          <br />
        </p>
      </div>
      <div className="c7-products-club-shipment">
        {items.map((item) => (
          <ClubSubscriptionItem
            key={item.id}
            clubSubscriptionShipment={clubSubscriptionShipment}
            club={club}
            item={item}
          />
        ))}
      </div>
    </>
  );
};

export default ClubSubscriptionInfo;
